// Refresh-attempt ids for POST /auth/refresh (also used as lease owner ids).
//
// One id per refresh attempt, repeated on that attempt's network retries, so a
// retry after a lost response gets the replacement refresh token the server
// already issued. The id only counts together with the refresh token; it is
// never stored beyond the attempt, logged or sent anywhere else.

const BYTES = 16;
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

function randomBytes() {
    const bytes = new Uint8Array(BYTES);
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        crypto.getRandomValues(bytes);
    } else {
        // Every supported browser has Web Crypto; this only keeps old test
        // environments working. The server accepts an id only inside 60 seconds.
        for (let i = 0; i < BYTES; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    return bytes;
}

/** 22-character URL-safe id (128 bits). */
export function newRefreshAttemptId() {
    let out = '';
    let bits = 0;
    let value = 0;
    for (const byte of randomBytes()) {
        value = (value << 8) | byte;
        bits += 8;
        while (bits >= 6) {
            bits -= 6;
            out += ALPHABET[(value >> bits) & 63];
        }
    }
    if (bits > 0) out += ALPHABET[(value << (6 - bits)) & 63];
    return out;
}
